import { AxiosInstance } from 'axios';
import {
  CreateCredentialRequest,
  CreateCredentialResponse,
  DeleteCredentialRequest,
  DeleteCredentialResponse,
  GetCredentialRequest,
  GetCredentialResponse,
  TestCredentialRequest,
  TestCredentialResponse,
  UpdateCredentialRequest,
  UpdateCredentialResponse,
  AssignToUserRequest,
  UnassignFromUserRequest,
  UnassignFromUserResponse,
  AssignToUserResponse,
} from './CredentialService.types';

export class CredentialService {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  create(request: CreateCredentialRequest) {
    return this.instance.post<CreateCredentialResponse>(
      `/loadboards/${request.routeParams.loadboardId}/credentials`,
      request.body,
      { baseURL: process.env.TRUKT_TMS_API_BASE_URL },
    );
  }

  get(request: GetCredentialRequest) {
    return this.instance.get<GetCredentialResponse>(
      `/loadboards/${request.routeParams.loadboardId}/credentials`,
      { baseURL: process.env.TRUKT_TMS_API_BASE_URL },
    );
  }

  delete(request: DeleteCredentialRequest) {
    return this.instance.delete<DeleteCredentialResponse>(
      `/loadboards/${request.routeParams.loadboardId}/credentials/${request.routeParams.credentialId}`,
      { baseURL: process.env.TRUKT_TMS_API_BASE_URL },
    );
  }

  update(request: UpdateCredentialRequest) {
    return this.instance.put<UpdateCredentialResponse>(
      `/loadboards/${request.routeParams.loadboardId}/credentials/${request.routeParams.credentialId}`,
      request.body,
      { baseURL: process.env.TRUKT_TMS_API_BASE_URL },
    );
  }

  test(request: TestCredentialRequest) {
    return this.instance.post<TestCredentialResponse>(
      `/loadboards/${request.routeParams.loadboardId}/credentials/test`,
      request.body,
      { baseURL: process.env.TRUKT_TMS_API_BASE_URL },
    );
  }

  assignToUser(request: AssignToUserRequest) {
    return this.instance.post<AssignToUserResponse>(
      `/loadboards/${request.routeParams.loadboardId}/credentials/${request.routeParams.credentialId}/users/${request.routeParams.userId}`,
    );
  }

  unassignFromUser(request: UnassignFromUserRequest) {
    return this.instance.delete<UnassignFromUserResponse>(
      `/loadboards/${request.routeParams.loadboardId}/credentials/${request.routeParams.credentialId}/users/${request.routeParams.userId}`,
    );
  }
}
